<template lang="pug">
  #tasks.center-panel.md-scrollbar.md-theme-default
    md-content.md-elevation-1(md-theme="white")
      .md-flex(md-theme="white")
        md-table(md-theme="white")
          md-table-row(v-for="(module, key) in modules" v-bind:key="module.id")
            md-table-cell.name
              router-link.module(v-bind:to="{ name: 'Properties', params: {code: module.code}, query: $route.query }")
                span.md-layout-row.md-gutter
                    span.md-flex.name
                        | {{module.description}}
            md-table-cell.load.right
              span.md-layout-row.md-gutter
                  span.md-flex.name {{(module.load) ? 'Загружен' : 'Не загружен' }}
            md-table-cell.active.right
              span.md-layout-row.md-gutter
                  span.md-flex.name {{(module.active) ? 'Активен' : 'Не активен' }}

</template>

<script>
  import Properties from '@/components/Properties'
  export default {
    components: {Properties},
    data() {
        return {
          title: 'Настройки модулей системы'
        }
    },
    computed: {
      modules() {
          return this.$store.state.module.modules;
      },
    },
    metaInfo() {
        return {

        }
    },
    created() {
      this.getModules();
      this.$store.commit('setTitle', 'Модули')
    },
    methods: {
      getModules() {
          this.$store.dispatch('module/getModules');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Overview.vue?0582ce8b